import { MinusIcon, PlusIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';
import { ActionsBox, ActionButton } from './CollaboratorChatbox.styles';

interface ExpandButtonProps {
  showStartChat?: boolean;
  onActionButtonClick: () => void;
  isChatBoxVisible?: boolean;
}
const ExpandButton = ({
  showStartChat = false,
  isChatBoxVisible = false,
  onActionButtonClick,
}: ExpandButtonProps) => {
  if (showStartChat) {
    return null;
  }
  return (
    <Box>
      <ActionsBox>
        <ActionButton noMargin showBorder onClick={onActionButtonClick}>
          {!isChatBoxVisible ? (
            <PlusIcon width={14} height={14} color="secondaryText" />
          ) : (
            <MinusIcon width={12} height={12} color="secondaryText" />
          )}
        </ActionButton>
      </ActionsBox>
    </Box>
  );
};

export default ExpandButton;
